import * as S from "./ExerciseItem.style";
import { useNavigate } from "react-router";
import { ExerciseCategory } from "@/common/types/video";

interface ExercistItemProps {
  exerciseCategory: ExerciseCategory;
}

export const ExerciseItem = ({ exerciseCategory }: ExercistItemProps) => {
  const navigate = useNavigate();

  return (
    <S.ExerciseItem onClick={() => navigate(exerciseCategory.path)}>
      <S.ExerciseIconBox>{exerciseCategory.icon}</S.ExerciseIconBox>
      <S.ExerciseItemTit>
        {exerciseCategory.title}
        <span>총 {exerciseCategory.count}개</span>
      </S.ExerciseItemTit>
    </S.ExerciseItem>
  );
};
